// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';

@Component({
  selector: 'e-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss'],
})
export class DividerComponent {
}
